module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros6.59806dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros6.png
// module id = 2156
// module chunks = 0